import { useState } from 'react'
import { Info } from 'lucide-react'

export default function Footer() {
  const [showInfo, setShowInfo] = useState(false)

  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <span className="app-footer-copy">© {new Date().getFullYear()} Brianza Social Debug</span>
        <button className="btn-info" onClick={() => setShowInfo(true)} title="Info progetto">
          <Info size={16} />
          <span style={{ marginLeft: 6, fontSize: 12 }}>Info</span>
        </button>
      </div>

      {showInfo && (
        <div className="info-panel" onClick={() => setShowInfo(false)}>
          <div className="info-content" onClick={e => e.stopPropagation()}>
            <h3>Brianza Social Debug</h3>
            <p>
              Dashboard per il monitoraggio del welfare, della sanità, dei servizi sociali e socio-sanitari della <strong>Provincia di Monza e della Brianza</strong>.
            </p>
            <p>
              Le informazioni presentate in questa dashboard sono frutto di un lavoro di raccolta, analisi e visualizzazione dei dati provenienti da <strong>fonti ufficiali e affidabili</strong>, con l'obiettivo di fornire una panoramica chiara e accessibile sulla <strong>situazione socio-sanitaria del territorio brianzolo</strong>. Le fonti dei dati includono, <strong>ATS BRIANZA, ASST Brianza, Ambiti Territoriali Sociali, Regione Lombardia e altri enti pubblici che monitorano la salute e il welfare nella provincia.</strong>
            </p>
            <p>Tutti i dati utilizzati provengono da dataset pubblici e consultabili online.</p>
            <button onClick={() => setShowInfo(false)}>Chiudi</button>
          </div>
        </div>
      )}
    </footer>
  )
}
